<template>
  <div>
    <div class="login-page text-center d-flex justify-content-center align-items-center">
      <b-form
        class="login-form"
        @submit.prevent="submit">
        <img
          class="mb-3"
          src="/images/brand/zoop-emblem.png"
          width="96"
          height="96">
        <h1 class="h4 mb-3 font-weight-normal">Sign in to ZoopLocal</h1>
        <b-alert
          :show="!!authError"
          variant="danger">
          {{ authError }}
        </b-alert>
        <b-form-input
          v-model="form.email"
          type="email"
          id="email"
          placeholder="Email address"
          required
          autofocus/>
        <b-form-input
          v-model="form.password"
          type="password"
          id="password"
          placeholder="Password"
          required />
        <b-overlay
          :show="isAuthLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button
            type="submit"
            variant="primary"
            block
            squared>
            Sign In
          </b-button>
        </b-overlay>
        <div class="mt-4 mb-3">
          <router-link
            to="/authentication/forgot"
            class="text-danger">
            Forgot Password
          </router-link>
          |
          <router-link
            to="/authentication/register"
            class="">
            Create an Account
          </router-link>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      authError: '',
      isAuthLoading: false,
    }
  },
  methods: {
    async submit() {
      this.isAuthLoading = true
      try {
        await this.$store.dispatch('Authentication/logIn', this.form)
        this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
      } catch (err) {
        this.authError = err.message
        console.log(err)
      }
      this.isAuthLoading = false
    },
  },
  mounted() {
    if (!!this.$route.query && !!this.$route.query.redirectFrom) {
      this.authError = 'Please log in or create an account'
    }
  },
}
</script>

<style>
.login-page {
  min-height: 500px;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
}

.login-form {
  max-width: 330px;
  width: 100%;
}

.login-form .form-control:focus {
  z-index: 2;
}

.login-form input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.login-form input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
